const home = {
  slides: [
    { tag: "Dubai Real Estate",   title0: "Exceptional",   title1: "Homes in Dubai",    sub: "Curated premium residences & investment opportunities across the Emirates." },
    { tag: "Featured Villas",     title0: "Luxury Villas", title1: "Palm Jumeirah",     sub: "Private beachfront estates with panoramic sea views and world-class amenities." },
    { tag: "Premium Apartments",  title0: "Modern Living", title1: "Downtown Dubai",    sub: "Sophisticated apartments with stunning Burj Khalifa views in the heart of the city." },
  ],
  scroll: "Scroll",
  search: {
    type:       "Type",
    typeAll:    "All types",
    location:   "Location",
    locAll:     "All Emirates",
    beds:       "Bedrooms",
    status:     "Status",
    statusAll:  "Buy or rent",
    statusSale: "For sale",
    statusRent: "For rent",
    btn:        "Search",
  },
  stats: {
    availability: "Availability",
    support:      "Full Support",
    satisfaction: "Client satisfaction",
    emirates:     "Emirates",
  },
  featured: {
    eyebrow:  "Featured properties",
    title:    "Premium",
    titleEm:  "listings",
    viewAll:  "View all",
  },
  bigFeature: {
    eyebrow:  "Featured property · Spain",
    desc:     "Spacious villa with panoramic sea views. Infinity pool, spa, gym, fully furnished — front line golf in Benahavis.",
    viewProp: "View property",
  },
  services: {
    eyebrow:  "What we offer",
    title:    "Our",
    titleEm:  "services",
    items: [
      { title: "Buying & Selling", desc: "Full support from first search to final handover. Every step guided with clarity." },
      { title: "Leasing",          desc: "Market pricing, tenant screening, contracts — compliant with UAE regulations." },
      { title: "Mortgage",         desc: "Expert guidance on financing and the ideal payment plan for your situation." },
      { title: "Conveyancing",     desc: "Full documentation and coordination with developers, banks, and government." },
    ],
  },
  partners: {
    label: "In partnership with UAE's leading developers",
  },
  cta: {
    title0:   "Ready to find your",
    title1:   "dream property?",
    sub:      "Our agents are available 7 days a week across the UAE.",
    whatsapp: "WhatsApp agent",
    send:     "Send message",
  },
};

export default home;
